import { useEffect, useState } from 'react';

export const useDebouncedValue = (value: string, delay: number, minSize: number = 3) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => value.length >= minSize && setDebouncedValue(value), delay);

        return () => clearTimeout(handler);
    }, [value, delay, minSize]);

    return debouncedValue;
};